// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline>.title[data-v-2a15d175]{margin-bottom:20px;font-size:30px!important;text-transform:uppercase}.section>.title[data-v-2a15d175]{margin-bottom:10px;font-size:15px!important;text-transform:uppercase}.vertical-column[data-v-2a15d175]{text-align:center}.v-stepper[data-v-2a15d175]{background:transparent}.v-alert[data-v-2a15d175]  h2:first-of-type{line-height:100%;margin-bottom:25px}.v-alert[data-v-2a15d175]  p{color:#000}", ""]);
// Exports
module.exports = exports;
